import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { crearSolicitud, TIPOS_ASESORIA } from '../../services/solicitudService';
import './FormularioAsesoria.css';

const FormularioAsesoria = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    tipoAsesoria: TIPOS_ASESORIA.COMPRA,
    mensaje: '',
    documento: ''
  });
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setError('');

    try {
      await crearSolicitud(formData);
      setEnviado(true);
      setFormData({
        nombre: '',
        email: '',
        telefono: '',
        tipoAsesoria: TIPOS_ASESORIA.COMPRA,
        mensaje: '',
        documento: ''
      });
      
      setTimeout(() => {
        navigate('/');
      }, 3000);
      
    } catch (error) {
      setError('Error al enviar la solicitud: ' + error.message);
    } finally {
      setEnviando(false);
    }
  };

  const tiposAsesoria = [
    { value: TIPOS_ASESORIA.COMPRA, label: 'Peritaje + Asesoria Integral' },
    { value: TIPOS_ASESORIA.VERIFICACION, label: 'Verificacion Legal' },
    { value: TIPOS_ASESORIA.TRASPASO, label: 'Acompanamiento en Traspaso' },
    { value: TIPOS_ASESORIA.OTRO, label: 'Consulta General' }
  ];

  if (enviado) {
    return (
      <div className="asesoria-container">
        <div className="asesoria-card exito">
          <div className="exito-icono">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 6L9 17L4 12" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2>Solicitud Enviada</h2>
          <p>Tu solicitud ha sido recibida. Un asesor de Golden Cars se comunicara contigo en las proximas 24 horas.</p>
          <button className="btn-volver" onClick={() => navigate('/')}>
            Volver al Inicio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="asesoria-container">
      <div className="asesoria-card">
        <div className="asesoria-header">
          <button className="btn-volver-inicio" onClick={() => navigate('/')}>
            ← Volver al Inicio
          </button>
          <h1>Solicitar Asesoria</h1>
          <p>Completa el formulario y un asesor especialista se comunicara contigo</p>
          <p className="header-note">"Mas que un peritaje, tu respaldo al comprar"</p>
        </div>

        <form onSubmit={handleSubmit} className="asesoria-form">
          <div className="form-group">
            <label>Nombre Completo</label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
              placeholder="Nombres y apellidos"
            />
          </div>

          <div className="form-row">
            <div className="form-group half">
              <label>Numero de Documento</label>
              <input
                type="text"
                name="documento"
                value={formData.documento}
                onChange={handleChange}
                required
                placeholder="Ej: 123456789"
              />
            </div>
            <div className="form-group half">
              <label>Telefono</label>
              <input
                type="tel"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                required
                placeholder="Ej: 3001234567"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Correo Electronico</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="correo@ejemplo.com"
            />
          </div>

          <div className="form-group">
            <label>Tipo de Servicio</label>
            <select
              name="tipoAsesoria"
              value={formData.tipoAsesoria}
              onChange={handleChange}
              required
            >
              {tiposAsesoria.map(tipo => (
                <option key={tipo.value} value={tipo.value}>{tipo.label}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Mensaje (opcional)</label>
            <textarea
              name="mensaje"
              value={formData.mensaje}
              onChange={handleChange}
              rows="4"
              placeholder="Describe brevemente tu caso o consulta..."
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button type="button" className="btn-cancelar" onClick={() => navigate('/')}>
              Cancelar
            </button>
            <button type="submit" className="btn-enviar" disabled={enviando}>
              {enviando ? 'Enviando...' : 'Solicitar Asesoria'}
            </button>
          </div>
        </form>

        <div className="info-nota">
          <p>Golden Cars – Peritaje & Respaldo Juridico S.A.S.</p>
          <p>"Mas que un peritaje, tu respaldo al comprar"</p>
        </div>
      </div>
    </div>
  );
};

export default FormularioAsesoria;